export default "__VITE_ASSET__124eef38__"